import styled, { css } from "styled-components"

import colors from "shared/styles/colors"
import { IElement } from "../../processEditor/model/IProcessData";
import { HashMap } from "../../shared/model/HashMap";
import { IStep, ITaskDetails, LoopParameter } from "../Models";
import { ElementType } from "../../processEditor/model/IProcessData";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";
import { ISearchState } from "processDetails/App";

const ShowRawOrFormattedColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.purpleTertiary
});

const ParameterValueNonFormattedBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.grey_5,
    [ThemeType.dark]: colors.dark3
})

const ParameterValueStyles = css`
    white-space: pre-wrap; 
    overflow-wrap: break-word;
    font-family: "CourierPrime-Regular", monospace;
    padding: 0 15px 0 22px;
`

export const ParameterValueDisplayPreformatted = styled.div`
    ${ParameterValueStyles};
`

export const ParameterValueNonFormatted = styled.pre`
    ${ParameterValueStyles};
    padding: 15px;
    background-color: ${ParameterValueNonFormattedBackgroundColor};
    border-radius: 20px;
`

export const ShowRawOrFormatted = styled.span`
    font-size: var(--small-text-font-size);
    color: ${ShowRawOrFormattedColor};
`

export interface ParameterViewerProps {
    id: string | undefined | null;
    elementType: ElementType | undefined | null;
    step: IStep | null;
    elementParameters: IElement | null | undefined;
    taskDetails: HashMap<ITaskDetails> | null | undefined;
    stepName: string | undefined | null;
    isExecutionType: boolean;
    currentIndexes: { [id: string]: number } | null | undefined;
    onLoopIndexChangeClick: ((id: string | undefined, newIndex: number) => void) | null;
    onSearch?: (searchText: string, stepId?: string) => void;
    onMouseOverSearchResult?: (stepId: string) => void;
    onSearchResultClicked?: (stepId: string, loopParameters: HashMap<LoopParameter>) => void;
    maxLoopIndex: number | null | undefined;
    subprocessExecutionId: string | null;
    environmentName: string | undefined;
    searchState?: ISearchState;

}

export interface LabelDisplayProps {
    label: string;
    isResult: boolean;
    isHovered?: boolean;
    copyLabelDotNotation?: React.ReactNode;
    copyLabelValue?: React.ReactNode;
}

export type BigNumber = { _isBigNumber: boolean, toFixed(): string }

export type PrimitiveParameterValue = string | boolean | undefined | null | BigNumber | number | object;

export type ParameterValue =
  | PrimitiveParameterValue
  | Array<ParameterValue>
  | { [key: string]: ParameterValue };
  
export interface RecursiveParameterDisplayProps {
    value: ParameterValue;
    parameterId: string | undefined;
    label?: string;
    parentPropertyName?: string | null;
    isResult: boolean;
    level?: number;
}

export  interface ParameterDisplayProps {
    value: string | number;
    label?: string;
    title?: string;
    parentPropertyName?: string | null;
    isResult: boolean;
}

export interface ExpandableParameterDisplayProps {
    label: string | undefined;
    rawVal: string;
    isResult: boolean;
    propertyPath?: string;
    level: number;
}

export enum JsonDisplayType {
    Result,
    Parameters,
    ProcessVariables,
}